import { Arrange, Button, Container, Spacer, Text } from '@loomhq/lens';
import React, { useCallback, useState } from 'react';
import { useSelector } from 'react-redux';

import * as oAuthKeys from 'constants/oAuthKeys';
import { ANON_RECORD_A_REPLY } from 'constants/onboarding';
import { selectCurrentVideoId, selectPlayerTime } from 'selectors/videoPlayer';
import * as auth from 'utilities/auth';
import { clearLoginErrors, signInHandler } from 'utilities/auth';

import appleIconSrc from 'img/icons/apple-black.svg';
import googleIconSrc from 'img/icons/google.svg';
import outlookIconSrc from 'img/icons/outlook-login.svg';
import slackIconSrc from 'img/icons/slack.svg';

import { SmartSigninRouting } from './smart-signin-routing';
import { afterOauthLogin } from '../utilities';

import styles from './styles.module.less';

const ShareSignIn = ({ email, emailError, setEmail, nextClickHandler }) => {
  const [password, setPassword] = useState('');

  const plainError = useSelector(state => state.login.plain_error);
  const passwordError = useSelector(state => state.login.password_error);
  const videoCurrentTime = useSelector(selectPlayerTime);

  const videoId = useSelector(state => state.modals?.options?.videoId);
  const addReplyId = useSelector(state => state.modals?.options?.addReplyId);
  const repliedToVideoId = useSelector(selectCurrentVideoId);

  const errorStr = plainError || passwordError || emailError;

  const connect = provider => {
    auth.openOAuthPopup(provider, {}, data => {
      if (data.loginSuccess) {
        afterOauthLogin({
          videoId,
          addReplyId,
          videoCurrentTime,
          repliedToVideoId,
          provider,
        });
      }
    });
  };

  const setEmailCallback = useCallback(
    val => {
      setEmail(val);
      clearLoginErrors();
      setPassword('');
    },
    [setEmail]
  );

  return (
    <Container paddingTop={2} paddingBottom={2}>
      <div className={styles.signinButtonsContainer}>
        <Arrange
          gap="small"
          columns={{ default: ['1fr'], xsmall: ['2fr', '2fr'] }}
        >
          <Button
            logoSrc={googleIconSrc}
            hasFullWidth={true}
            size="medium"
            onClick={() => connect(oAuthKeys.GOOGLE)}
          >
            with Google
          </Button>

          <Button
            logoSrc={slackIconSrc}
            hasFullWidth={true}
            onClick={() => connect(oAuthKeys.SLACK)}
          >
            with Slack
          </Button>
          <Button
            logoSrc={appleIconSrc}
            hasFullWidth={true}
            onClick={() => connect(oAuthKeys.APPLE)}
          >
            with Apple
          </Button>
          <Button
            logoSrc={outlookIconSrc}
            hasFullWidth={true}
            onClick={() => connect(oAuthKeys.WINDOWS)}
          >
            with Outlook
          </Button>
        </Arrange>
      </div>

      <Container paddingY={3}>
        <div className={styles.line} />
      </Container>

      <Text size="small" fontWeight="medium">
        Or email address
      </Text>
      <Spacer top={1}>
        <SmartSigninRouting
          errorStr={errorStr}
          email={email}
          setEmail={setEmailCallback}
          password={password}
          setPassword={val => {
            setPassword(val);
            clearLoginErrors();
          }}
          signInHandler={authType =>
            signInHandler({
              authType,
              email,
              password,
              source: ANON_RECORD_A_REPLY,
              anonVideoProps: {
                videoId,
                addReplyId,
                videoCurrentTime,
                repliedToVideoId,
              },
            })
          }
          nextClickHandler={nextClickHandler}
          videoCurrentTime={videoCurrentTime}
        />
      </Spacer>
    </Container>
  );
};

export default ShareSignIn;
